var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1923_25279)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.37928 3.29391H3.04197C2.7133 3.29391 2.3981 3.42448 2.1657 3.65688C1.9333 3.88928 1.80273 4.20448 1.80273 4.53315V13.2078C1.80273 13.5364 1.9333 13.8516 2.1657 14.084C2.3981 14.3164 2.7133 14.447 3.04197 14.447H11.7166C12.0453 14.447 12.3605 14.3164 12.5929 14.084C12.8253 13.8516 12.9558 13.5364 12.9558 13.2078V8.87046",
    stroke: "#227645",
    strokeWidth: 1.23923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0275 2.36456C12.274 2.11807 12.6083 1.97958 12.9569 1.97958C13.3055 1.97958 13.6398 2.11807 13.8863 2.36456C14.1328 2.61106 14.2713 2.94539 14.2713 3.29399C14.2713 3.64259 14.1328 3.97691 13.8863 4.22341L7.99995 10.1098L5.52148 10.7294L6.1411 8.25092L12.0275 2.36456Z",
    stroke: "#227645",
    strokeWidth: 1.23923,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1923_25279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.8708,
    height: 14.8708,
    fill: "white",
    transform: "translate(0.564453 0.815521)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.6545808eba1d7ed1c813c7095106c911.svg";
export { ForwardRef as ReactComponent };